/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Ha Van Truong (hvtruong3@rsuppartners.com)
 *
 * @description
 *
 * @created at Mon Mar 10 2025
 **/

import { useTheme } from "@emotion/react";

import { useProperties } from "@/frameworks/libraries/properties";
import { Icon, Row } from "@/frameworks/designStuff";
import { colors } from "@/frameworks/core/styles";
import staticResource from "@/frameworks/designStuff/components/Contents/Avatar/staticResource";

const ChatMentionItem = ({ item }: { item: { id: string; value: string; profileImagePath?: string } }) => {
	const properties = useProperties();
	const theme = useTheme();

	return (
		<Row style={{ display: "flex", alignItems: "center", gap: "8px" }}>
			{item?.id === "@all" || item?.value === "all" ? (
				<Row
					style={{
						width: "28px",
						height: "28px",
						borderRadius: "50%",
						background: colors?.gradient_40_100_w60
					}}
					verticalAlign="center"
					horizonAlign="center"
				>
					<Icon name="People24" size={16} />
				</Row>
			) : (
				<img
					src={`${properties.default.webDomain}${item?.profileImagePath}`}
					style={{
						width: "28px",
						height: "28px",
						borderRadius: "50%"
					}}
					alt="mention"
					onError={(event: React.SyntheticEvent<HTMLImageElement, Event>) => {
						event.currentTarget.src = staticResource.img_default_profile_32x32;
					}}
				/>
			)}
			<span
				style={{
					color: theme?.colors?.neutral_80_100 || "#000",
					display: "inline-block",
					maxWidth: "200px",
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis"
				}}
			>
				{item.value}
			</span>
		</Row>
	);
};

export default ChatMentionItem;
